import _ from 'lodash';

export default function convertOperations(operations, itemLookup) {
  return _.mapValues(operations, (operationItems, key) => {
    const items = operationItems.map(itemLookup).filter((item) => item);

    if (items.length > 0) {
      return items;
    } else {
      // eslint-disable-next-line no-console
      console.error(`No item found for operation "${key}" tried to find:`, _.flatMap(operationItems, 'ItemNo').join(', '));
      return undefined;
    }
  });
}
